import React from "react";
import { Header } from "../../components/Header";
import "./styles.less";
import { Footer } from "../../components/FooterV2";
import { HomeTryOn } from "../../blocks/home-try-on";
import { Helmet } from "react-helmet";
import { AboutusBanner } from "../../blocks/aboutus-banner";
import { AboutusProcess } from "../../blocks/aboutus-process";
import { SolutionCustomer } from "../../blocks/solution-customer";
import { AboutusFuture } from "../../blocks/aboutus-future";
import { AboutusJoin } from "../../blocks/aboutus-join";
import { useTranslation } from "react-i18next";
import { SolutionSceneScreen } from "../../blocks/aboutus-scroll";
import { Notice } from "../../components/Notice";

export const AboutusPage = () => {
  const { t } = useTranslation();
  return (
    <div className="aboutus-page">
      <Helmet>
        <title>
          中国版OKTA-Authing身份云-SSO单点登录系统-MFA多因素认证-统一身份认证平台-零信任-IDaaS-以开发者为中心
        </title>
      </Helmet>
      <Header hasNotice />
      <AboutusBanner />
      <SolutionSceneScreen />
      {/* <AboutusProcess /> */}
      <AboutusFuture />
      <SolutionCustomer
        customTitle={t("aboutus.cutomer.subtitle")}
        // customSubTitle={t("aboutus.cutomer.subtitle")}
      />
      <AboutusJoin />
      <HomeTryOn hasBg />
      <Footer />
    </div>
  );
};
